import React, { FunctionComponent } from "react";
import { Box } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import EmailTemplatesComponent from "components/EmailTemplates";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      background: "#fff"
    }
  })
);

export const EmailTemplates: FunctionComponent = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <EmailTemplatesComponent />
    </Box>
  );
};

export default EmailTemplates;
